import './Footer.scss'
import { FaFacebook, FaInstagram, FaTiktok, FaEnvelope } from 'react-icons/fa'
import LogoWhite from '../../assets/images/logo-white.png'
import { Container } from 'react-bootstrap'

export default function Footer() {
  return (
    <div className="konekto-footer py-5">
      <Container fluid>
        <div className="links">
          <img src={LogoWhite} />
          <p className="mt-3">
            Povežite se direktno s firmama
            <br /> koje odgovaraju vašim potrebama i ubrzajte <br /> svoj
            poslovni rast.
          </p>

          {/* <a href="#">Uslovi korištenja</a>
          <a href="#">Polica privatnosti</a> */}
        </div>

        <div className="newsletter">
          <p>
            Pretplatite se na newsletter <br /> da ostanete informisani.
          </p>
          <input
            type="email"
            className="form-control rounded-pill"
            placeholder="Upiši email"
          />

          <div className="text-end">
            <button className="btn btn-primary rounded-pill">
              Pretplatite se
            </button>
          </div>

          <div className="social-links">
            <span className="me-2">Prati nas:</span>
            <a
              href="https://www.facebook.com/profile.php?id=61582501210998#!"
              target="_blank"
              rel="noreferrer">
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/konekto.business/"
              target="_blank"
              rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="#">
              <FaTiktok />
            </a>
          </div>
        </div>
      </Container>
    </div>
  )
}
